<template>
  <Slider />
  <News />
</template>

<script>
import Slider from '@/components/Slider.vue';
import News from '@/components/News.vue';

export default {
  name: 'Home',
  components: {
    Slider,
    News,
  },
  created() {
  },
};
</script>


<style lang="scss">
</style>
